import type { ApiResponse } from "api/ApiResponses";
import type { AppState } from "ee/reducers";
import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import {
  ReduxActionErrorTypes,
  ReduxActionTypes,
} from "ee/constants/ReduxActionConstants";
import { all, call, delay, put, select, take } from "redux-saga/effects";
import { validateResponse } from "sagas/ErrorSagas";
import { isEmpty } from "lodash";
import HomeApi from "api/HomeAPI";

export function* getRecentlyCaseSaga() {
  try {
    const response: ApiResponse = yield call(HomeApi.getRecentlyCase, {});
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.FETCH_RECENTLY_CASE_SUCCESS,
        payload: {
          data: response.data,
        },
      });
      return isEmpty(response?.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* getQuickAccessSaga() {
    try {
      const response: ApiResponse = yield call(HomeApi.getQuickAccess, {});
      const isValidResponse: boolean = yield validateResponse(response);
      if (isValidResponse) {
        yield put({
          type: ReduxActionTypes.FETCH_QUICK_ACCESS_SUCCESS,
          payload: {
            data: response.data,
          },
        });
        return isEmpty(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  }


export function* pinApplicationSaga(action: ReduxAction<any>) {
  try {
    const response: ApiResponse = yield call(HomeApi.pinApplication, action.payload);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.SET_PIN_APPLICATION_SUCCESS,
        payload: {
          pinTop: action.payload.pinTop,
        },
      });
      yield put({
        type: ReduxActionTypes.FETCH_ENTITIES_OF_WORKSPACE_INIT,
        payload: {
          workspaceId: action.payload.workspaceId,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
}

